/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hidden[_ngcontent-%COMP%]{visibility:hidden}.loader-overlay[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;z-index:500000}.loader[_ngcontent-%COMP%]{overflow:hidden;background-color:transparent;display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:end;-webkit-box-align:end;align-items:end;height:100%;width:100%}.loader[_ngcontent-%COMP%]   .spinner-grow[_ngcontent-%COMP%]   .spinner-grow-lg[_ngcontent-%COMP%]{color:#fff;background-color:red!important}"];
export { styles as styles };
